import React from 'react';
import PropTypes from 'prop-types';

const Toast = props => (
  <div className="toast">{props.children}</div>
);

Toast.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Toast;



// WEBPACK FOOTER //
// ./src/components/Toast/index.js